import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-multipoint-modal-error-installation',
  templateUrl: './multipoint-modal-error-installation.component.html',
  styleUrls: ['./multipoint-modal-error-installation.component.scss']
})
export class MultipointModalErrorInstallationComponent {

  constructor(
    private dialogRef: MatDialogRef<MultipointModalErrorInstallationComponent>,
    @Inject(MAT_DIALOG_DATA) public dataDialog
  ) { }

  public closeModal(event: string): void {
    this.dialogRef.close(event);
  }

}
